import React from 'react';
import Link from './Link';
import Picture from './Picture/Picture';
import { PictureProps } from './Picture/PictureProps';
import Titleblock from './Titleblock';

export interface CardProps
{
    picture: PictureProps;
    title: string;
    content:string;
    actionUrl:string;
    actionName: string;
}

const Card = (props: CardProps) => {
    return (<div className="relative flex-1 justify-between mt-2 md:ml-2 md:mr-2 md:mt-0 lg:m-2 rounded-lg overflow-hidden shadow-lg bg-white">
        <Picture pictureClass="border-black" imageClass="border-black" {...props.picture}></Picture>
        <article className="relative h-40">
        <Titleblock titleLevel="h4" className="text-center font-medium pt-4" title={props.title}></Titleblock>
        {props.content && <p className="m-2 text-center text-opacity-70 text-gray-700" dangerouslySetInnerHTML={{ __html: props.content }}></p>}
        <Link classname="primaryButton block absolute bottom-2 left-2 right-2" target="" url={props.actionUrl} name={props.actionName} title={props.actionName}></Link>
        </article>
    </div>);
}

export default Card;